var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74054 8.74109H10.5183V10.5188H8.74054V8.74109Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74054 13.4816H10.5183V15.2594H8.74054V13.4816Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3697 19.9997H21.184V18.2222H19.9988V9.63021C19.9988 9.08025 19.7804 8.55267 19.3914 8.1637C19.0025 7.77476 18.4751 7.55634 17.9249 7.55634H15.2586V6.07497C15.2586 5.52485 15.0399 4.99743 14.651 4.60846C14.2621 4.21952 13.7347 4.0011 13.1845 4.0011H10.5181L8.74038 4.00109L6.07401 4.0011C5.5239 4.0011 4.99647 4.21954 4.60751 4.60846C4.21854 4.99738 4.00014 5.5248 4.00014 6.07497V18.2222H2.81494V20L14.3697 19.9997ZM17.9249 9.33383C18.0035 9.33383 18.0789 9.36503 18.1345 9.42042C18.1901 9.47601 18.2213 9.55145 18.2213 9.62998V18.2219H15.2585V9.3337L17.9249 9.33383ZM5.77769 6.0747C5.77769 5.91102 5.91036 5.77834 6.07405 5.77834H13.1846C13.2634 5.77834 13.3386 5.80955 13.3942 5.86514C13.4498 5.92074 13.481 5.99617 13.481 6.0747V18.222H5.77785L5.77769 6.0747Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.0d40e0772d823cd7d9728ad65cef3b93.svg";
export { ForwardRef as ReactComponent };